import React, {Component} from 'react';
import { translate } from '../Services/translation';

class PdfButton extends Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        setTimeout(function() {
            if (typeof this.props.recalcWidth === 'function') this.props.recalcWidth();
        }.bind(this), 20);
    }

    render() {
        return (
            <button
                className={`${this.props.cssClass} ${this.props.active ? 'active' : ''}`}
                onClick={() => this.props.onClick(this.props.articleNumber)}
                dangerouslySetInnerHTML={{ __html: this.props.active ? translate('pdfbutton.regret') : this.props.label }}
            ></button>
        );
    }
}

export default PdfButton;